import type { ComputedRef, Ref } from 'vue';

import type { FleequidStatsResponseDto } from '~/apiClient';

type UseFleequidStatsReturn = {
    soldVehicles: ComputedRef<number>;
    countries: ComputedRef<number>;
    companies: ComputedRef<number>;
    availableVehicles: ComputedRef<number>;
    totalDossiers: ComputedRef<number>;
    employees: ComputedRef<number>;
    _raw: {
        apiStats: Ref<FleequidStatsResponseDto | null>;
    };
};

const FALLBACK_API_STATS: FleequidStatsResponseDto = {
    soldVehicles: 1000,
    countries: 70,
    companies: 4000,
    availableVehicles: 700,
};

export const useFleequidStats = (): UseFleequidStatsReturn => {
    const apiStats = useState<FleequidStatsResponseDto | null>('fleequidStats', () => null);

    return {
        soldVehicles: computed(() => roundWithPrecision(apiStats.value?.soldVehicles ?? FALLBACK_API_STATS.soldVehicles, 100)),
        countries: computed(() => roundWithPrecision(apiStats.value?.countries ?? FALLBACK_API_STATS.countries, 10)),
        companies: computed(() => roundWithPrecision(apiStats.value?.companies ?? FALLBACK_API_STATS.companies, 100)),
        // Currently unused due to a tragicomic misunderstanding (see: https://adorea.atlassian.net/browse/PT-452?focusedCommentId=37295)
        availableVehicles: computed(() =>
            roundWithPrecision(apiStats.value?.availableVehicles ?? FALLBACK_API_STATS.availableVehicles, 100, 'floor')
        ),
        totalDossiers: computed(() => 2200), // TODO: to be implemented by apiGetFleequidStats?
        employees: computed(() => 70),
        // For exclusive use of the fleequidStats plugin
        _raw: {
            apiStats,
        },
    };
};
